/**
 * Copyright © 2026 Adnuntius AS.
 */
import {LocalStorage} from "./local-storage";
import * as _ from "lodash";

const ONE_HOUR = 60 * 60 * 1000;
const TEN_MINUTES = 10 * 60 * 1000;

type CreativeTiming = {
  timing: number;
  scannedCreatives: Array<any>;
};

export class LocalScannedCreativeInfo {
  private static instance: LocalScannedCreativeInfo;
  private static readonly SCANNER_CREATIVES = 'scannedCreatives';

  creativeTiming: CreativeTiming;

  private constructor() {
  }

  public static obtain(): LocalScannedCreativeInfo {
    if (!this.instance) {
      this.instance = new LocalScannedCreativeInfo();
    }
    this.instance.refresh();
    return this.instance;
  }

  private save() {
    LocalStorage.obtain().setItem(LocalScannedCreativeInfo.SCANNER_CREATIVES, this.creativeTiming);
  }

  private refresh() {
    const localStorageInfo = LocalStorage.obtain().getItem(LocalScannedCreativeInfo.SCANNER_CREATIVES);
    this.creativeTiming = _.isEmpty(localStorageInfo) ? _.isEmpty(this.creativeTiming) ? {} : this.creativeTiming : localStorageInfo;
  }

  setScannedCreatives(scannedCreatives: Array<any>) {
    this.creativeTiming.timing = Date.now();
    this.creativeTiming.scannedCreatives = scannedCreatives;
    this.save();
  }

  getScannedCreatives(forceCall: boolean): Array<any> {
    LocalScannedCreativeInfo.instance.refresh();
    if ((!forceCall || (forceCall && Date.now() - TEN_MINUTES < this.creativeTiming.timing)) && this.creativeTiming.scannedCreatives && (Date.now() - ONE_HOUR < this.creativeTiming.timing)) {
      return this.creativeTiming.scannedCreatives;
    }
    return [];
  }
}
